<template>
  <i class="icon-container" :style="cssVars" @click="onClick">
    <svg :class="`icons-${name}`">
      <use :href="iconId" />
    </svg>
  </i>
</template>

<script>
import svgSprite from './assets/sprite.svg'

export default {
  name: 'Icons',
  props: {
    /**
     * Specifies which icon to use from the built-in set of icons.
     *
     * @type {string}
     */
    name: {
      type: String,
      required: true
    },
    // TODO: Fill & stroke is commented out until we have the tokens for colours
    /**
     * The color to use for the fill of the icon.
     *
     * @type {string}
     */
    // fill: {
    //   type: String,
    //   default: 'primary'
    // },
    // /**
    //  * The color to use for the stroke of the icon.
    //  *
    //  * @type {string}
    //  */
    // stroke: {
    //   type: String,
    //   default: 'primary'
    // },
    /**
     * Specifies the label to use for accessibility. Defaults to the icon name.
     *
     * @type {string}
     */
    ariaLabel: {
      type: String,
      default: function () {
        return this.name
      }
    },
    /**
     * Set the icon to hidden, respectively `true`, to remove it from the accessibility tree.
     *
     * @type {boolean}
     */
    ariaHidden: {
      type: Boolean,
      default: true
    },
    /**
     * This will rotate icon right by degrees
     *
     * @type {number}
     */
    rotate: {
      type: Number,
      default: 0
    },
    /**
     * This will depend on whether the icon is clickable
     *
     * @type {boolean}
     */
    isClickable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    iconId() {
      return `${svgSprite}#${this.name}`
    },
    cssVars() {
      // return {}
      const vars = {
        '--rotate-deg': `${this.rotate}deg`
      }
      if (this.isClickable) {
        vars['--cursor-type'] = 'pointer'
      }

      return vars
    }
  },
  methods: {
    onClick(_) {
      if (!this.isClickable) return

      this.$emit('clicked')
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-container {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  min-width: 0;
  transform: rotate(var(--rotate-deg));
  width: var(--icon-size);
  height: var(--icon-size);
  cursor: var(--cursor-type);
  svg {
    width: var(--icon-size);
    height: var(--icon-size);
    margin: 8.5%;
    fill: var(--icon-fill-color);
    stroke: var(--icon-stroke-color);
    &:hover {
      fill: var(--icon-hover-fill-color, $black);
      stroke: var(--icon-hover-stroke-color, none);
    }
  }
}

.icons {
  &-heart {
    --icon-fill-color: none;
    --icon-stroke-color: #{$black};
    &:hover {
      --icon-hover-fill-color: none;
      --icon-hover-stroke-color: #{$black};
    }
  }
}
</style>
